import {
  Contact,
  ContactInformations,
  Container,
  Content,
  FooterInformations,
  InformationText,
} from "./styles";

import Logo from "../../images/logoWhite.svg";
import IconWhatsApp from "../../images/icons/whatsapp.svg";
import IconEmail from "../../images/icons/email.svg";
import IconLocation from "../../images/icons/location.svg";

const Footer = () => {
  return (
    <Container>
      <ContactInformations>
        <Content>
          <img src={Logo} alt="logo" />

          <InformationText>
            <h2>Você precisa de ajuda jurídica?</h2>
            <span>Nós estamos aqui para te ouvir, te orientar e resolver.</span>
          </InformationText>

          <Contact>
            <a href="https://wa.me/5511994602852" target="_blank">
              <img src={IconWhatsApp} alt="whatsapp" />
              (11) 99460-2852
            </a>

            <a href="mailto: carlacassavia@cassaviaadvocacia.com.br">
              <img src={IconEmail} alt="email" />
              carlacassavia@cassaviaadvocacia.com.br
            </a>

            <div>
              <img src={IconLocation} alt="localização" />
              Vila Mariana – São Paulo/SP
            </div>
          </Contact>
        </Content>
      </ContactInformations>

      <FooterInformations>
        <span>
          © 2025 Cassavia Advocacia | Todos os direitos reservados -
          Desenvolvido por{" "}
          <a href="https://ypb.com.br/" target="_blank">
            YPB MKT DIGITAL
          </a>
        </span>
      </FooterInformations>
    </Container>
  );
};

export default Footer;
